import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const RootPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  maxHeight: '100vh',
  boxSizing: 'border-box',
  padding: theme.spacing(3),

  '& h2': {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  '& .scar-textField': {
    marginBottom: theme.spacing(2),
  },
}));

export const FirmListContainer = styled(List)(({ theme }) => ({
  overflow: 'hidden',
  overflowY: 'auto',
  marginLeft: `-${theme.spacing(1)}px`,
  marginRight: `-${theme.spacing(1)}px`,
  boxSizing: 'border-box',
  maxHeight: 'calc(100vh - 150px)',
  backgroundColor: 'transparent',

  '& .MuiListItem-root': {
    backgroundColor: 'transparent',
    borderBottom: 'none',
    borderTop: 'none',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },

  '& .MuiListItem-divider': {
    borderBottom: 'none',
  },
}));

export const ListItem = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
}));

export const AvatarStyled = styled('div')(({ theme }) => ({
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: theme.spacing(1.5),
  color: theme.palette.primary.main,
  fontSize: '1rem',
  fontWeight: 'bold',
  backgroundColor: theme.palette.common.white,
}));

export const LoadingText = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const TextFieldWrapper = styled('div')({
  width: '100%',
});

export const LogoutButtonContainer = styled('div')({
  textAlign: 'right',
  marginTop: '1.5em',

  '& button': {
    fontSize: '0.875rem',
  },
});
